var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlFuneralFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 17H19C19.621 16.5343 20.125 15.9304 20.4721 15.2361C20.8193 14.5418 21 13.7762 21 13V12C21 8 16 2 16 2C16 2 11 8 11 12V13C11 13.7762 11.1807 14.5418 11.5279 15.2361C11.875 15.9304 12.379 16.5343 13 17H7C6.20435 17 5.44129 17.3161 4.87868 17.8787C4.31607 18.4413 4 19.2044 4 20V28H28V20C28 19.2044 27.6839 18.4413 27.1213 17.8787C26.5587 17.3161 25.7956 17 25 17ZM13 12C13 10.25 14.51 7.50002 16 5.33002C17.49 7.50002 19 10.25 19 12V13C18.9983 13.6189 18.8051 14.2222 18.4471 14.7271C18.089 15.2319 17.5835 15.6137 17 15.82V12H15V15.82C14.4165 15.6137 13.911 15.2319 13.5529 14.7271C13.1949 14.2222 13.0017 13.6189 13 13V12Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlFuneralFilled);
export default __webpack_public_path__ + "static/media/gl_funeral_filled.7d33d27586d025d9a770c9b5c8bfdb6c.svg";
export { ForwardRef as ReactComponent };